import type { TimeIntent, TimeIntentOptionValue } from './types';
import type { SegmentedButtonOption } from '../../..';
import { formatRelativeDateForParis, isParisTz, t } from '../../../../index';

export const formatTimeIntent = (timeIntent: TimeIntent, withSuffix = true) => {
  let formattedDate = '';

  if (timeIntent.type === 'DA') {
    formattedDate = formatRelativeDateForParis(timeIntent.date);
  } else {
    formattedDate = t('pwa.common.today');
  }

  const time = timeIntent.type === 'DA' ? timeIntent.time : t('pwa.common.asap');

  return `${formattedDate}, ${time}${withSuffix && !isParisTz() ? t('pwa.common.local-time') : ''}`;
};

export const timeIntentOptions: SegmentedButtonOption<TimeIntentOptionValue>[] = [
  {
    label: t('pwa.common.go-at'),
    value: 'DEPARTURE',
  },
  {
    label: t('pwa.common.arrive-at'),
    value: 'ARRIVAL',
  },
];
